import { DOTHelper } from 'lib/dot/DOTHelper.ts';
import { PageType } from 'lib/dot/enum/pageType.ts';
import { HomepageTab } from 'lib/dot/enum/homepageTab.ts';
import type { TabId } from 'components/homepage/signals.ts';
import type { BooleanAnalytics } from 'lib/dot/types.ts';

export type HomepageAnalytics = {
	action: 'hp';
	advertCount: number;
};

export type HomepageAnalyticsStoreInitializer = {
	myProfile: boolean;
	sellerFilter: boolean;
	usedGoods: boolean;
};
export type HomepageAnalyticsStore = {
	myProfile: BooleanAnalytics;
	sellerFilter: BooleanAnalytics;
	usedGoods: BooleanAnalytics;
};

export function initHomepageStore({ myProfile, sellerFilter, usedGoods }: HomepageAnalyticsStoreInitializer) {
	const data: HomepageAnalyticsStore = {
		myProfile: DOTHelper.sanitizeBoolean(myProfile),
		sellerFilter: DOTHelper.sanitizeBoolean(sellerFilter),
		usedGoods: DOTHelper.sanitizeBoolean(usedGoods),
	};
	DOTHelper.setStore(data);
}

export function sendHomepageAnalytics(advertCount: number) {
	const data: HomepageAnalytics = {
		action: PageType.HOMEPAGE,
		advertCount: advertCount,
	};

	return DOTHelper.hit(data);
}

export type TabClickAnalytics = {
	action: 'tabClick';
	tab: string;
};

export const TabIdToTabAnalyticsIdMap: Record<TabId, HomepageTab> = {
	'v-okoli': HomepageTab.NEARBY,
	popularni: HomepageTab.POPULAR,
	rozbalene: HomepageTab.USED,
	ulozene: HomepageTab.SAVED,
};

export function sendHomepageTabAnalytics(tab: HomepageTab) {
	const data: TabClickAnalytics = {
		action: 'tabClick',
		tab: tab,
	};

	return DOTHelper.hit(data);
}

export type HomepageImpress = {
	pageType: typeof PageType.HOMEPAGE;
};

export function sendHomepageImpression() {
	const data: HomepageImpress = { pageType: 'hp' };

	DOTHelper.impress(data);
}
